import { all, fork } from 'redux-saga/effects';
import { combineReducers } from 'redux';
import { PersistPartial } from 'redux-persist/es/persistReducer';

import * as auth from './ducks/auth.duck';
import * as users from './ducks/users.duck';
import * as profile from './ducks/profile.duck';
import * as transactions from './ducks/transactions.duck';
import * as promocodes from './ducks/promocodes.duck';

import * as agreement from './ducks/agreement.duck';
import * as tariff from './ducks/tariff.duck';
import * as tariffs from './ducks/tariffs.duck';
import * as chat from './ducks/chat.duck';

import { metronic } from '../../_metronic';

export type TAppActions =
  | auth.TActions
  | transactions.TActions
  | promocodes.TActions
  | users.TActions
  | profile.TActions
  | agreement.TActions
  | tariff.TActions
  | tariffs.TActions
  | chat.TActions;

export interface IAppState {
  i18n: typeof metronic.i18n.reducer;
  builder: typeof metronic.builder.initialState;
  auth: auth.IInitialState & PersistPartial;
  transactions: transactions.IInitialState & PersistPartial;
  promocodes: promocodes.IInitialState & PersistPartial;
  users: users.IInitialState & PersistPartial;
  profile: profile.IInitialState & PersistPartial;
  agreement: agreement.IInitialState;
  tariff: tariff.IInitialState & PersistPartial;
  tariffs: tariffs.IInitialState & PersistPartial;
  chat: chat.IInitialState & PersistPartial;
}

export const rootReducer: (
  state: IAppState,
  action: TAppActions
) => IAppState = combineReducers<IAppState, TAppActions>({
  auth: auth.reducer,
  transactions: transactions.reducer,
  promocodes: promocodes.reducer,
  users: users.reducer,
  profile: profile.reducer,
  i18n: metronic.i18n.reducer,
  builder: metronic.builder.reducer,
  agreement: agreement.reducer,
  tariff: tariff.reducer,
  tariffs: tariffs.reducer,
  chat: chat.reducer,
});

export function* rootSaga() {
  yield all(
    [
      auth.saga,
      transactions.saga,
      promocodes.saga,
      users.saga,
      profile.saga,
      agreement.saga,
      tariff.saga,
      chat.saga,
    ].map(saga => fork(saga))
  );
}
